import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Service from '../../util/Service';
import { Stack } from '@mui/material';
import RulesPopover from '../page/portal/user/RulesPopover';

export default function BmpnForm(props) {
  const { open, setOpen, processo, onSubmit } = props;
  const [nome, setNome] = React.useState('');
  const [regra, setRegra] = React.useState('');
  const [descricao, setDescricao] = React.useState('');

  React.useEffect(() => {
    if (processo) {
      setNome(processo.nome)
      setRegra( processo.rule)
      setDescricao(processo.descricao)
    }
  }, [processo])

  const handleClose = () => {
    setOpen(false);
  };
  const handleSalvar = () => {
    const dado = {
      ...processo,
      nome: nome,
      rule: regra,
      descricao: descricao
    }
 
    Service.POST("/api/bpmn/salvarProcesso", dado).then(resp => {
      if (onSubmit) onSubmit(resp);

    }).catch(error => {
      console.error(error)
      // setWait(false);
      // setMensagem(error ? error : 'Oops! Something went wrong. Please try again!');
    })
    handleClose();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());
          const email = formJson.email;
          handleClose();
        },
      }}
    >
      <DialogTitle>Dados do processo</DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2}>
          <TextField
            autoFocus
            required
            margin="dense"
            name="nome"
            value={nome && nome}
            label="Nome do Processo"
            onChange={(e) => setNome(e.target.value)}
            // fullWidth
            variant="standard"
          />
          {/* <TextField            
            margin="dense"
            name="regra"
            value={regra && regra}
            label="Regra de quem terá acesso ao processo"
            onChange={(e) => setRegra(e.target.value)}
            // fullWidth
            variant="standard"
          /> */}
          <RulesPopover action={(r)=>setRegra(r.nome)} showTxt={true} regra={regra} />

        </Stack>
        <TextField
          name="descricao"
          label="descricao"
          multiline
          rows={4}
          fullWidth
          value={descricao && descricao}
          onChange={(e) => setDescricao(e.target.value)}
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSalvar}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
}
